// extracted by mini-css-extract-plugin
export default {"control":"Tracker2Controls_control__dsdQl"};